export default __webpack_public_path__ + "static/media/man2.d39156f8.png";